import PlanningStatusEnum from '../Enums/PlanningStatusEnum';

export default class PlanningItemStatusUpdateItem {
  PricingIds: number[];
  CountryNames: string[];
  Periods: { apply: boolean }[];
  To: string;
  CancellationDecision: string;
  CancellationComment: string;

  constructor(selectedItems, numberOfPlanningDetails) {
    const items = selectedItems ?? [];
    this.PricingIds = items.map((item) => item.PricingId);
    this.CountryNames = Array.from(new Set(items.map((item) => item.CountryName).filter(Boolean)));
    const periodCount =
      typeof numberOfPlanningDetails === 'undefined' || numberOfPlanningDetails < 1 ? 1 : numberOfPlanningDetails;
    this.Periods = Array.from({ length: periodCount }, () => ({ apply: true }));
    this.To = PlanningStatusEnum.ClientConfirmed;
    this.CancellationDecision = '';
    this.CancellationComment = '';
  }
}
